export default "__VITE_ASSET__A0nYRgn___"